import {
  actions as asyncDataFetch,
  actionTypes as dataFetchActionTypes,
} from '@buffer-mono/async-data-fetch'

// @ts-expect-error TS(7031) FIXME: Binding element 'dispatch' implicitly has an 'any'... Remove this comment to see the full error message
export default ({ dispatch, getState }) =>
  // @ts-expect-error TS(7006) FIXME: Parameter 'next' implicitly has an 'any' type.
  (next) =>
  // @ts-expect-error TS(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
  (action) => {
    next(action)
    const state = getState()

    switch (action.type) {
      case `user_${dataFetchActionTypes.FETCH_SUCCESS}`:
        dispatch(
          asyncDataFetch.fetch({
            name: 'globalAccount',
          }),
        )
        break
      default:
        break
    }
  }
